import { httpCreate } from './http';

const http = httpCreate('/um/setting');

export const umSetting = {
	getList() {
		return http.get(``);
	},
	setList(body) {
		return http.post(``, body);
	},
};
